import React from 'react';
import {setSignUp} from "../../Features/Misc/loginSlice";
import {useDispatch} from "react-redux";

function SignUpQuery() {

    const dispatch = useDispatch();

    return (
        <h3 className={"text-lg text-white/75"}>
            Don't have an account? <span onClick={() => dispatch(setSignUp())} className={"text-white underline cursor-pointer"}>Sign up</span>
        </h3>
    );

}

export default SignUpQuery;
